import ApplicationController from "./application_controller";

/* This is the custom StimulusReflex controller for the VintageFlavourizer Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = ["spinner"];

  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  connect() {
    super.connect();
    console.log("VintageFlavourizer controller connected");
  }

  /* Reflex specific lifecycle methods.
   *
   * For every method defined in your Reflex class, a matching set of lifecycle methods become available
   * in this javascript controller. These are optional, so feel free to delete these stubs if you don't
   * need them.
   *
   * Important:
   * Make sure to add data-controller="vintage-flavourizer" to your markup alongside
   * data-reflex="VintageFlavourizer#dance" for the lifecycle methods to fire properly.
   *
   * Example:
   *
   *   <a href="#" data-reflex="click->VintageFlavourizer#dance" data-controller="vintage-flavourizer">Dance!</a>
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "VintageFlavourizer#dance"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  // Spinner logic for search
  beforeFind(element, reflex, noop, reflexId) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }
  }

  findSuccess(element, reflex, noop, reflexId) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  findError(element, reflex, error, reflexId) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  findHalted(element, reflex, noop, reflexId) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  afterFind(element, reflex, noop, reflexId) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  finalizeFind(element, reflex, noop, reflexId) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }

  beforeAdd(element, reflex, noop, reflexId) {
    console.log("before add", element, reflex, reflexId);
    console.log("flavour-id:", element.dataset["flavourId"]);
    console.log("vintage-id:", element.dataset["vintageId"]);
  }

  addSuccess(element, reflex, noop, reflexId) {
    console.log("add success", element, reflex, reflexId);
  }

  addError(element, reflex, error, reflexId) {
    console.error("add error", element, reflex, error, reflexId);
  }

  addHalted(element, reflex, noop, reflexId) {
    console.warn("add halted", element, reflex, reflexId);
  }

  afterAdd(element, reflex, noop, reflexId) {
    console.log("after add", element, reflex, reflexId);
  }

  finalizeAdd(element, reflex, noop, reflexId) {
    console.log("finalize add", element, reflex, reflexId);
  }

  // beforeRemove(element, reflex, noop, reflexId) {
  //  console.log("before remove", element, reflex, reflexId)
  // }

  // removeSuccess(element, reflex, noop, reflexId) {
  //   console.log("remove success", element, reflex, reflexId)
  // }

  // removeError(element, reflex, error, reflexId) {
  //   console.error("remove error", element, reflex, error, reflexId)
  // }

  // removeHalted(element, reflex, noop, reflexId) {
  //   console.warn("remove halted", element, reflex, reflexId)
  // }

  // afterRemove(element, reflex, noop, reflexId) {
  //   console.log("after remove", element, reflex, reflexId)
  // }

  // finalizeRemove(element, reflex, noop, reflexId) {
  //   console.log("finalize remove", element, reflex, reflexId)
  // }
}
